import useCurrentAccount from "./useCurrentAccount"

const EMPTY_FLAGS = {}

const useFeatureFlag = () => {
  const currentAccount = useCurrentAccount()

  return currentAccount?.featureFlags || EMPTY_FLAGS
}

export default useFeatureFlag
